import {
  BoynerOrderProduct,
  boynerOrderProductFromResponse,
} from './BoynerOrderProduct';
import { BoynerOrderStatus } from './BoynerOrderStatus';

export interface BoynerOrder {
  boynerID: number;
  products: BoynerOrderProduct[];
  status: BoynerOrderStatus;
  createdAt: Date;
}

export const boynerOrderFromResponse = (responseData: any): BoynerOrder => ({
  boynerID: responseData.boyner_id,
  products: (responseData.products ?? []).map((product: any) =>
    boynerOrderProductFromResponse(product),
  ),
  status: responseData.status,
  createdAt: new Date(responseData.created_at),
});
